import { GraphQLQuery } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { useCallback } from "react";
import { CallbackQuery, CallbackResponse } from "../API";
import { callback as callbackQuery } from "../graphql/queries";

export function useTriloCallback() {
    const triloCallback = useCallback(
        async (url: string, paymentId?: string): Promise<Partial<CallbackResponse>> => {
            const result = await API.graphql<GraphQLQuery<CallbackQuery>>({
                query: callbackQuery,
                variables: { url, paymentId },
            });

            if (!result.data?.callback) {
                return {};
            }

            return result.data?.callback;
        },
        []
    );

    return { triloCallback };
}
